export function getCSSCustomProperty(name, element) {
    if (element === void 0) { element = document.documentElement; }
    window.getComputedStyle(element).getPropertyValue(name);
}
export function setCSSCustomProperty(name, value, element) {
    if (element === void 0) { element = document.documentElement; }
    element.style.setProperty(name, value);
}
export function removeCSSCustomProperty(name, element) {
    if (element === void 0) { element = document.documentElement; }
    element.style.removeProperty(name);
}
